module.exports = window;


//////////////////
// WEBPACK FOOTER
// external "window"
// module id = xCsw
// module chunks = 18